import React from 'react';
import propTypes from 'prop-types';
import { ShieldOff } from 'lucide-react';
import CarrierLucideIcon from 'components/CarrierLucideIcon/CarrierLucideIcon';
import { UPLINE_DISABLED_SECTION_MESSAGE } from 'helpers/carriers/carrierSectionIconLegends';
import style from './CarrierSectionIconLegend.module.scss';

function CarrierSectionIconLegend({
  legends = [],
  showUplineDisabled = false
}) {
  if (!legends.length && !showUplineDisabled) return null;

  return (
    <div className={style.legend}>
      {showUplineDisabled && (
        <div className={style.legendItem}>
          <span
            className={style.legendDescription}
            title={UPLINE_DISABLED_SECTION_MESSAGE}
          >
            {UPLINE_DISABLED_SECTION_MESSAGE}
          </span>
          <ShieldOff
            size={18}
            className={style.uplineDisabledIcon}
            aria-hidden
          />
        </div>
      )}
      {legends.map(legend => (
        <div
          key={`${legend.carrierIcon}|${legend.carrierIconColor}|${legend.carrierIconDescription}`}
          className={style.legendItem}
        >
          <span
            className={style.legendDescription}
            title={legend.carrierIconDescription}
          >
            {legend.carrierIconDescription}
          </span>
          <CarrierLucideIcon
            name={legend.carrierIcon}
            color={legend.carrierIconColor}
            size={18}
          />
        </div>
      ))}
    </div>
  );
}

CarrierSectionIconLegend.propTypes = {
  legends: propTypes.arrayOf(
    propTypes.shape({
      carrierIcon: propTypes.string.isRequired,
      carrierIconColor: propTypes.string,
      carrierIconDescription: propTypes.string.isRequired
    })
  ),
  showUplineDisabled: propTypes.bool
};

export default CarrierSectionIconLegend;
